import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './UserAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import moment from 'moment';

export const STATUS_PENDING = 'pending';
export const STATUS_PROCESSING = 'processing';
export const STATUS_SENT = 'sent';
export const STATUS_COMPLETE = 'complete';

export const TYPE_NEW = 'new';
export const TYPE_AFFILIATE = 'affiliate';

export const STATUSES = {
    STATUS_PENDING,
    STATUS_PROCESSING,
    STATUS_SENT,
    STATUS_COMPLETE,
};

export const TYPES = {
    TYPE_NEW,
    TYPE_AFFILIATE,
};

const SCHEDULE_AT_FORMAT = 'MM-DD-YYYY hh:mm A';

class UserAccountConfirmationAppResource extends AppResource {

    readableStatus(timezone = 'utc') {
        if (!this.status) {
            return 'Unknown';
        }

        switch (this.status) {
            case STATUS_PROCESSING:
                return 'Processing';
            case STATUS_PENDING:
                if (!this.scheduleAt) {
                    return 'Not Scheduled';
                }
                const scheduleAt = moment.isMoment(this.scheduleAt) ? this.scheduleAt.format(SCHEDULE_AT_FORMAT) :
                    moment(this.scheduleAt).format(SCHEDULE_AT_FORMAT);
                return 'Scheduled ' + scheduleAt;
            case STATUS_SENT:
                const sentAt = moment.isMoment(this.sentAt) ? this.sentAt.tz(timezone).format(SCHEDULE_AT_FORMAT) :
                    moment(this.sentAt).tz(timezone).format(SCHEDULE_AT_FORMAT);
                return 'Sent ' + sentAt;
            case STATUS_COMPLETE:
                const updatedAt = moment.isMoment(this.updatedAt) ? this.updatedAt.tz(timezone).format(SCHEDULE_AT_FORMAT) :
                    moment(this.updatedAt).tz(timezone).format(SCHEDULE_AT_FORMAT);
                return 'Complete ' + updatedAt;
        }
    }

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'user-account-confirmation';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'users/accounts/confirmations';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'key',
            'userUuid',
            'organizationUuid',
            'status',
            'scheduleAt',
            'timezone',
            'type',
            'organization',
            'user',
            'sentAt',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            userUuid: {
                type: 'string',
                presence: !this.exists,
            },
            sentAt: {
                datetime: true,
            },
            scheduleAt: {
                datetime: true,
            },
        };
    }

}

export default UserAccountConfirmationAppResource;
